// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"510e171b","102":"ee9a88e1","507":"93180d20","550":"9bb9dc6d","702":"8d872d84","725":"b1877c24","828":"9884b03d"}[chunkId] + ".chunk.js";
};